import { render, staticRenderFns } from "./AbsenceOptionsTemplate.vue?vue&type=template&id=aff013fc&"
import script from "./AbsenceOptionsTemplate.vue?vue&type=script&lang=js&"
export * from "./AbsenceOptionsTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports